export default __webpack_public_path__ + "static/media/Gauntlets of the Dark Messenger.dee65163.jpg";